export default __webpack_public_path__ + "static/Mensur-e12df2c84525f733fe858570b0eaf1d1.png";